import React from "react";
import { Screen } from '~common/screen';
import { StyledScreen } from '~common/screen';
import { Styled } from './styled'
import { IPrice } from "~/types/IPrice";
import { usePriceData } from "~/hooks/usePriceData";

interface IAnalyticsProps {
  isLegalPerson?: boolean;
  service?: IPrice;
}

const Analytics: React.FC<IAnalyticsProps> = (props) => {
  const { isLegalPerson, service } = props;
  const analyticsPrice = usePriceData(isLegalPerson, service)

  return (
    <Screen
      title={<span>Бизнес-<StyledScreen.GreenText>аналитика</StyledScreen.GreenText></span>}
      bottomLine={true}
    >
      <Styled.Container>
        <Styled.Left>
          <Styled.IconWrapp>
            <Styled.IconBg>
              <Styled.IconPlace>
                <img src={process.env.PUBLIC_DIR + '/images/index_page/quality_standarts/icon_3.svg'} />
              </Styled.IconPlace>
            </Styled.IconBg>
          </Styled.IconWrapp>
        </Styled.Left>
        <Styled.Right>
          <Styled.Title>Не понимаете нагрузку сотрудников?</Styled.Title>
          <Styled.Text>Onlinepbx посчитает количество звонков, длительность разговоров, среднюю оценку от клиентов — вы получите все данные для анализа ситуации.</Styled.Text>
          <Styled.Title>Не знаете, что происходит на линии прямо сейчас?</Styled.Title>
          <Styled.Text>Онлайн-дашборд от onlinepbx покажет количество клиентов на линии, количество операторов в разговоре и время ожидания клиентов.</Styled.Text>
          <Styled.Price>{analyticsPrice} / 30 дней</Styled.Price>
        </Styled.Right>
      </Styled.Container>
    </Screen>
  )
}

export { Analytics }
